/* eslint-disable no-useless-return */
import { useEffect, useState, useContext } from 'react';
import useApi, { GET_HEATMAP_SERIES, GET_HEATMAP_DATA, GET_HEATMAP_DATES } from 'hooks/useApi';
import UserSessionContext from 'context/UserSessionContext';
import * as ACTIONS from 'context/actions';

export const useHeatmapSeries = () => {
  const [filteredSeries, setFilteredSeries] = useState();
  const apiParams = GET_HEATMAP_SERIES();
  const [state] = useApi(apiParams);
  const { isLoading, isError, data, error } = state;

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (isError && error) {
      return;
    }

    if (data) {
      const formattedSeries = [...data.data].map(series => ({
        label: series.name,
        value: series.timeSeriesSetId
      }));
      setFilteredSeries(formattedSeries);
    }
  }, [isLoading, isError, error, data]);

  return [state, filteredSeries];
};

export const useHeatmapDates = () => {
  const [filteredDates, setFilteredDates] = useState();

  const apiParams = GET_HEATMAP_DATES();
  const [state] = useApi(apiParams);
  const { isLoading, isError, data, error } = state;

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (isError && error) {
      return;
    }

    if (data) {
      const formattedDates = [...data.data].map(date => ({
        label: date.date,
        value: date.date
      }));
      setFilteredDates(formattedDates);
    }
  }, [isLoading, isError, error, data]);

  return [state, filteredDates];
};

export const useFetchHeatmapData = () => {
  const { dispatch } = useContext(UserSessionContext);
  const [state, makeRequest] = useApi();
  const { isLoading, isError, data } = state;

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (isError) {
      return;
    }

    if (data) {
      const { heatmapSettings } = data;

      dispatch({ type: ACTIONS.UPDATE_USER_HEATMAP_SETTINGS, payload: heatmapSettings });
    }
  }, [isLoading, isError, data, dispatch]);

  const fetchHeatmapData = ({
    timeSeriesSetId,
    date,
    sortBy,
    groupBy,
    showPortfolios,
    showIndexes,
    showProposedManagers
  }) => {
    const registerParams = GET_HEATMAP_DATA({
      timeSeriesSetId,
      date,
      sortBy,
      groupBy,
      showPortfolios,
      showIndexes,
      showProposedManagers
    });
    makeRequest(registerParams);
  };
  return [state, fetchHeatmapData];
};
